export const POSITIVE = "lightTheme"
export const NEGATIVE = "darkTheme"

export const ALPHABET = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
]

export const FEEDBACK_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfCQzZHtaDSiWNdwiJa3TIzsyhjEbYyyHwfrcwIKn_UmdVaKA/viewform"

export const API_DOCUMENTATION_URL =
  "https://nasa-impact.github.io/admg-backend/documentation/api_doc.html"

export const MOVING_PLATFORMS = [
  "Jet",
  "Prop",
  "UAV",
  "AUV",
  "USV",
  "Drifting Buoy",
  "Ships/Boats",
  "Saildrone",
  "Air Platforms",
]
